module.exports = __webpack_public_path__ + "img/user.e8000457.png";